import React from "react";
import styles from "../../styles/components/noResult.module.scss";
import {
    Box,
} from "@mui/material";
import magnifying from "../../../src/public/assets/images/icon-magnifying.svg";
import assest from "../../json/assest";

const ManagerConfirmNoResult = (props) => {
    const { hideApprovedTab, approvedTabName, filterRowProps } = props;
    return (
        <Box className={`${styles.emptyTable} ${styles.confirmEmpty}`}>
            <Box className={styles.emptyTableImg}>
                {props?.query?.length > 0 ? (
                    <img src={magnifying} width={45} height={45} alt="icon" />
                ) : (
                    <img src={assest.noresultImg} width={36} height={41} alt="" />
                )}
            </Box>
            <p>
                {props?.query?.length > 0 ? (
                    <>
                        We couldn’t find any matching {props?.heading} videos for{" "}
                        <span style={{ fontWeight: "700", color: "#525252" }}>
                            {props?.query}
                        </span>
                    </>
                ) : (
                    <>
                        We couldn't find any {props?.heading} videos within the
                        specified date range.
                    </>
                )}
            </p>
        </Box>
    )
}

export default ManagerConfirmNoResult